import { Box, Center, Spinner, Image } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const MotionBox = motion(Box);

const LoadingScreen = ({ isLoading, isTransparent }) => {
  const [isVisible, setIsVisible] = useState(isLoading);
  const [baseUrl, setBaseUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setBaseUrl(window.location.origin);
    }

    let timer;
    if (isLoading) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => {
        setIsVisible(false);
      }, 500);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  return (
    <AnimatePresence>
      {isVisible && (
        <MotionBox
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          bg={isTransparent ? "rgba(255, 255, 255, 0.7)" : "white"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ opacity: { duration: 0.5 } }}
          zIndex={999}
        >
          <Center mb={4}>
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1, repeat: Infinity, repeatType: "loop" }}
            >
              <Image
                src={`${baseUrl}/assets/contex-logo-light.png`}
                alt="Logo"
                w="200px"
                mb={4}
              />
            </motion.div>
          </Center>
          <Center>
            <Spinner
              thickness="4px"
              speed="0.65s"
              color="brand.900"
              size="xl"
            />
          </Center>
        </MotionBox>
      )}
    </AnimatePresence>
  );
};

export default LoadingScreen;
